import Resources from '../../helpers/resources';
import { handleResourceError, handleResourceSuccess } from '../../helpers/resource-handlers';

export const ACADEMIC_YEAR_RETRIEVED = 'ACADEMIC_YEAR_RETRIEVED';

function getAcademicYear() {
    return dispatch => Resources
        .academicYear
        .get()
        .send()
        .then(
            payload => handleResourceSuccess(dispatch, payload, {
                type: ACADEMIC_YEAR_RETRIEVED,
                payload: payload.data
            }),
            error => handleResourceError(dispatch, error)
        );
}

export default {
    getAcademicYear
};



// WEBPACK FOOTER //
// ./containers/overview/academic-year-actions.js